import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  success: false,
  error: false,
  games: [],
  gamesCount: 0,
  numberOfPages: 0,
  gameLink: "",
  moreGamesLoading: false,
  searchGames: [],
  searchNoOfPages: 0,
  searchCount: 0,
  searchLoading: false,
  moreSearchGamesLoading: false,
  isGameStarted: false,
  topGameLoading: false,
  topGames: [],
  moreTopGameLoading: false,
  pageNumber: 0,
  searchPage: 0
};

const casinoGamesSlice = createSlice({
  name: "casinoGames",
  initialState,
  reducers: {
    getGamesStart: (state, action) => {
      if (action.payload?.loadMoreGames) {
        state.moreGamesLoading = true;
      }
      if (!action.payload?.loadMoreGames) {
        state.loading = true;
        state.pageNumber = action.payload.pageNumber;
      }
    },
    getGamesSuccess: (state, action) => {
      if (
        action.payload.page != 1 &&
        action.payload.page <= state.numberOfPages
      ) {
        state.loading = false;
        state.moreGamesLoading = false;
        state.games = [...state.games, ...action.payload.games];
      }
      if (action.payload.page == 1) {
        state.loading = false;
        state.games = [...action.payload.games];
      }
      state.success = true;
      state.numberOfPages = action.payload?.numberOfPages || 0;
      state.gamesCount = action.payload?.gamesCount || 0;
    },
    getGamesFailure: (state) => {
      state.loading = false;
      state.moreGamesLoading = false;
      state.error = true;
    },
    getGameLinkStart: (state) => {
      state.loading = true;
      state.isGameStarted = true;
    },
    getGameLinkSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.isGameStarted = true;
      state.gameLink = action.payload;
    },
    getGameLinkFailure: (state) => {
      state.loading = false;
      state.error = true;
      state.isGameStarted = false;
    },
    getSearchedGamesStart: (state, action) => {
      if (action.payload.loadMoreSeachedGames) {
        state.moreSearchGamesLoading = true;
        state.searchLoading = true;
      }
      if (!action.payload.loadMoreSeachedGames) {
        state.searchLoading = true;
      }
      if (action.payload.page == 1) {
        state.searchGames = initialState.searchGames;
      }
    },
    resetIsGameStarted: (state) => {
      state.isGameStarted = false;
    },
    getSearchedGamesSuccess: (state, action) => {
      if (action.payload.page == 1) {
        state.searchLoading = false;
        state.searchGames = [...action.payload.searchGames];
      }
      if (
        action.payload.page != 1 &&
        action.payload.page <= action.payload.searchNoOfPages
      ) {
        state.searchLoading = false;
        state.searchGames = [
          ...state.searchGames,
          ...action.payload.searchGames
        ];
      }
      state.moreSearchGamesLoading = false;
      state.searchPage = action.payload.page;

      state.success = true;
      state.searchNoOfPages = action.payload.searchNoOfPages;
      state.searchCount = action.payload.searchCount;
    },
    getSearchedGamesFailure: (state) => {
      state.searchLoading = false;
      state.loading = false;
      state.error = true;
    },
    resetSearchGames: (state) => {
      state.searchGames = [];
      state.searchNoOfPages = 0;
      state.searchCount = 0;
      state.searchLoading = false;
    },
    getTopGamesStart: (state, action) => {
      if (action.payload.loadMoreTopGame) {
        state.moreTopGameLoading = true;
      }

      if (!action.payload.loadMoreTopGame) {
        state.topGameLoading = true;
      }
    },
    getTopGamesSuccess: (state, action) => {
      if (action.payload.pageNumber == 1) {
        state.topGameLoading = false;
        state.topGames = [...action.payload.topGames];
      }
      if (
        action.payload.pageNumber != 1 &&
        action.payload.pageNumber <= state.numberOfPagesTopGame
      ) {
        state.topGameLoading = false;

        state.topGames = [...state.topGames, ...action.payload.topGames];
      }

      state.numberOfPagesTopGame = action.payload?.numberOfPagesTopGame || 0;
      state.gamesCountTopGames = action.payload?.gamesCountTopGames || 0;
    },
    getTopGamesFailure: (state, action) => {
      state.topGameLoading = false;
      state.moreTopGameLoading = false;
    }
  }
});

export const {
  getGamesStart,
  getGamesSuccess,
  getGamesFailure,
  getGameLinkStart,
  getGameLinkSuccess,
  getGameLinkFailure,
  getSearchedGamesStart,
  getSearchedGamesSuccess,
  resetIsGameStarted,
  getSearchedGamesFailure,
  resetSearchGames,
  getTopGamesStart,
  getTopGamesSuccess,
  getTopGamesFailure
} = casinoGamesSlice.actions;

export default casinoGamesSlice.reducer;
